import script from "./factory-testing-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./factory-testing-item.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__